import { PaymentChannel } from './payment';
import dayjs from 'dayjs';

export enum TransactionType {
  Payment = 100,
  Refund = 200,
}
// export enum TransactionPaymentMethod {
//   Cash = 1,
//   Tenpay = 2,
//   Alipay = 3,
//   INVALID = -2,
// }
export enum TransactionScene {
  POS = 1,
  Weapp = 2,
  System = -1,
}

export interface TransactionLog {
  id: number;
  poiId: number;
  userId: number;
  orderSn: string;
  type: TransactionType;
  status: 200;
  paymentMethod: PaymentChannel;
  scene: TransactionScene;
  amount: number;
  amountAfter: number;
  outTradeNo: string;
  memo: string;
  refundNo: string;
  operator: string;
  addTime: string | dayjs.Dayjs;
}

export interface TransactionLogRefundInfo extends TransactionLog {
  availableAmount: number;
}
